import { render, staticRenderFns } from "./therm-form.component.vue?vue&type=template&id=26444255"
import script from "./therm-form.component.vue?vue&type=script&lang=js"
export * from "./therm-form.component.vue?vue&type=script&lang=js"
import style0 from "./therm-form.component.vue?vue&type=style&index=0&id=26444255&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports